<template>
  <billing-dialog
    class="visitor-management-plan-details"
    :width="`${dialogWidth}px`"
    :visible.sync="visible"
    :before-close='handleCancel'
    @back-event="handleCancel"
  >
    <h1 class="visitor-management-plan-details__title">
      {{ title }}
    </h1>
    <price-list
      ref="priceList"
      class="visitor-management-plan-details__price-list"
      :showDecimalPoint="$context.is.desktop"
      :plan-category="planCategory"
      :unit-type="planUnitMap.user"
    />
    <ul class="visitor-management-plan-details__desc">
      <li v-for="item in descList" :key="item">
        <span>{{ item }}</span>
      </li>
    </ul>
  </billing-dialog>
</template>

<script>
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import PriceList from '@/components/price-list.vue';
import { planUnitMap } from '@/common/product-unit';
import BillingDialog from '@/components/billing-dialog.vue';

export default {
  name: 'VisitorManagementPlanDetails',
  mixins: [ConfirmComponent],
  components: {
    BillingDialog,
    PriceList,
  },
  props: {
    title: String,
    planCategory: String,
    planTrackingName: String,
  },
  data() {
    return {
      visible: false,
      planUnitMap,
      dialogWidth: 520,
      descList: [
        this.$t('billing.visitor_management.plan_details.desc1'),
        this.$t('billing.visitor_management.plan_details.desc2'),
        this.$t('billing.visitor_management.plan_details.desc3'),
        this.$t('billing.visitor_management.plan_details.desc4'),
      ],
    };
  },
  watch: {
    /**
     * watch visible and fire event
     * @param {boolean} val visible
     */
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          this.calcDialogWith();
        })
      }
      this.$tracking.buyInteraction('plan details', `${this.planTrackingName} plan details - ${val ? 'impression' : 'exit'}`);
    },
  },
  methods: {
    calcDialogWith() {
      const priceListWith = this.$refs.priceList.$el.offsetWidth;
      // padding-left + padding-right = 120
      const newWidth = priceListWith + 120;
      if (newWidth > this.dialogWidth) {
        this.dialogWidth = newWidth;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

.visitor-management-plan-details {
  ::v-deep .zm-dialog {
    padding: 72px 60px;
    &__header {
      padding-bottom: 0;
    }
  }
  &__title {
    color: #00053d;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.5em;
  }

  &__price-list {
    margin-bottom: 4px;
    padding: 8px 0;
    @include media(mobile, tablet) {
      margin-top: 4px;
    }
  }

  &__desc {
    list-style-image: url('../../../../assets/plans/check.svg');
    color: #00053d;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5em;
    margin-left: 20px;
    > li {
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0;
      }
      span {
        position: relative;
        left: 4px;
      }
    }
  }
}

.zm-theme--dark {
  .visitor-management-plan-details__title {
    color: $dark-text-color2;
  }
  .visitor-management-plan-details__desc {
    color: $dark-text-color;
  }
}
</style>
